import { useState } from "react";
import { useAuth } from "./AuthProvider";
import DatumLogo from "./datum-logo.svg"
import React from 'react'
import './css/Login.css';

const Login = () => {

    const [loginProviders] = React.useState([
        {
            SystemName: "or",
            pim: "or",
            cls: "or",
            clientId: "apiuser",
            clientSecret: "x6rbCUPwQC4Mn-_CsGWx",
            scope: "or-pim360 or-cls360",
            Latitude: "Approved Latitude",
            Longitude: "Approved Longitude"
        },
        {
            SystemName: "dap-demo",
            pim: "dap-demo",
            cls: "dap-demo",
            clientId: "serviceaccount",
            clientSecret: "C>T,4MA#e[9BRgs>om@h",
            scope: "dap-demo-pim360 dap-demo-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "datum360-cdp",
            pim: "datum360-cdp",
            cls: "datum360-cdp",
            clientId: "datum360service",
            clientSecret: "VVGWewVA3kE>e7654=!1",
            scope: "datum360-cdp-pim360 datum360-cdp-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "amer-demo",
            pim: "amer-process-demo",
            cls: "amer-demo",
            clientId: "datum360service",
            clientSecret: "mSh@6gTT4ozTRj%iF6`T",
            scope: "amer-process-demo-pim360 amer-demo-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "apac-demo",
            pim: "apac-process-demo",
            cls: "apac-demo",
            clientId: "datum360service",
            clientSecret: "AE-Q%tSI.$itk|RB]Pq5",
            scope: "apac-process-demo-pim360 apac-demo-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "emea-demo",
            pim: "emea-process-demo",
            cls: "emea-demo",
            clientId: "datum360service",
            clientSecret: "VP{2_g(64bjliM}Jvj=(",
            scope: "emea-process-demo-pim360 emea-demo-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "amer-sandbox",
            pim: "amer-process-sb-demo",
            cls: "amer-sandbox",
            clientId: "datum360service",
            clientSecret: "6D[**PvOn5K1>W*8NEiU",
            scope: "amer-process-sb-demo-pim360 amer-sandbox-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "apac-sandbox",
            pim: "apac-process-sb-demo",
            cls: "apac-sandbox",
            clientId: "datum360service",
            clientSecret: "ze*0WK8av~rvs}zCj&2T",
            scope: "apac-process-sb-demo-pim360 apac-sandbox-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },
        {
            SystemName: "emea-sandbox",
            pim: "emea-process-sb-demo",
            cls: "emea-sandbox",
            clientId: "datum360service",
            clientSecret: "i,`[<?&j9PZY0/=td4/[",
            scope: "emea-process-sb-demo-pim360 emea-sandbox-cls360",
            Latitude: "latitude",
            Longitude: "longitude"
        },

    ])
  const auth = useAuth();
  const handleSubmitEvent = (url, clientId, clientSecret, scope, SystemName, latitude,longitude, pim, cls) => {
      auth.loginAction({
        url: url,
        clientId: clientId,
        clientSecret: clientSecret,
        scope: scope,
        systemName: SystemName,
        pim: pim,
        cls: cls
      });

      localStorage.setItem("Latitude", latitude);
      localStorage.setItem("Longitude", longitude);
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
        <div class="container">
            <div class="login-box bg-white p-6 rounded-lg shadow-lg">
                <h2  class="text-center text-lg font-bold">Sign in</h2>
                <ul>
                {
                    loginProviders.map((provider) => {
                        return (
                            <li className="p-1">
                                <button type="submit" onClick={() => handleSubmitEvent(provider.url, provider.clientId, provider.clientSecret, provider.scope, provider.SystemName, provider.Latitude, provider.Longitude, provider.pim, provider.cls)} class="text-center text-lg font-bold btn">Sign in to {provider.SystemName}</button>
                            </li>
                        )
                    })
                }
                </ul>
            </div>
            <div class="bottom-logo">
                <img src={DatumLogo}/>
            </div>
        </div>
    </div>
  );
};

export default Login;